import { AppWindow, RotateCw, Smartphone, WifiOff } from "lucide-react";
import { m } from "motion/react";
import { Trans, useTranslation } from "react-i18next";

import * as brand from "~/brand";
import { preview } from "~/const";
import { urls } from "~/urls";

import { Link } from "../link";

export function LongerThanUsual() {
	const { t } = useTranslation();

	return (
		<m.div
			key="longer-than-usual"
			animate={{ opacity: 1, y: 0 }}
			className="flex w-full max-w-md flex-col gap-4 px-4 pt-8"
			initial={{ opacity: 0, y: -20 }}
		>
			<p className="font-semibold">{t("loading_slow")}</p>
			<ul className="ml-4 flex list-disc flex-col gap-2">
				{preview && (
					<li>
						This is a
						{" "}
						<strong>preview</strong>
						{" "}
						version of
						{" "}
						{brand.name}
						{" "}
						that automatically turns off after a few minutes of use. It may take a minute to start up again.
					</li>
				)}
				<li>
					<Trans
						components={{
							icon: <WifiOff className="inline-block size-4 shrink-0" />
						}}
						i18nKey="error_tip_connection"
					/>
				</li>
				<li>{t("error_tip_restart_app")}</li>
				<li>
					<Trans
						components={{
							"browser-icon": <AppWindow className="inline-block size-4 shrink-0" />,
							"device-icon": <Smartphone className="inline-block size-4 shrink-0" />
						}}
						i18nKey="error_tip_update_app"
					/>
				</li>
				<li>
					<button
						className="underline"
						type="button"
						onClick={() => location.reload()}
					>
						<RotateCw className="mr-1 inline-block size-4 shrink-0" />
						{t("refresh_the_app")}
					</button>
				</li>
				{urls.resources.contact && (
					<li>
						<Trans
							components={{
								contact: (
									<Link
										className="whitespace-nowrap lowercase underline"
										href={urls.resources.contact}
									/>
								)
							}}
							i18nKey="error_tip_contact"
						/>
					</li>
				)}
			</ul>
		</m.div>
	);
}
